type IsUnion<T, U extends T = T> = T extends unknown
  ? [U] extends [T]
    ? false
    : true
  : false;

export type ParticularKey<T extends keyof any> = IsUnion<T> extends true
  ? never // cannot be an union
  : string extends T
    ? never // cannot be generic string
    : symbol extends T
      ? never // cannot be generic symbol
      : number extends T
        ? never // cannot be generic number
        : T; // now it must be a single key
